import {Button, Space, Table, Tag} from 'antd';
import React, {useEffect, useState} from 'react';
import serviceHelper from '../../../../helpers/functions/service.helper';
import {Link} from 'react-router-dom';
import dayjs from 'dayjs';
import {CaretDownFilled, CaretUpFilled, DownloadOutlined, LinkOutlined} from '@ant-design/icons';
import moment from 'moment';
import numberHelper from '../../../../helpers/functions/number.helper';
import merchantSettlementService from "../../../../services/ewallet_integration/merchant_settlement.service";

const MerchantSettlementList = ({filter, merchant, setRefresh, refresh}) => {
    const [state, setState] = useState({
        loading: false,
        submitted_document_loading: null,
        // documents : [],
        listing: [],

        // refresh
        refresh: 0,

        // pagination
        page: 0,
        display_size: 10,
        count: null,
    });
    const paginateChange = (key, value) => {
        // set state
        setState(state => ({...state, [key]: value}));
    }

    const fetchList = async () => {
        setState(state => ({...state, loading: true,}));

        const {search, start_date, end_date,} = filter;
        const response = await merchantSettlementService?.settlementListingByMerchantId(merchant?.merchant_id, {
            search,
            start_date: start_date,
            end_date: end_date,

            // pagination
            page: Math.max(0, state?.page - 1),
            size: state?.display_size,

            // order
            order: "created_at",
            order_position: 'DESC',
        });

        const {count, rows,} = response?.data;
        setState(state => ({...state, loading: false, listing: rows, count,}));
    }

    useEffect(() => {
        fetchList();
    }, [state?.page, filter])


    useEffect(() => {
        if(refresh) {
            fetchList();
            setRefresh(false);
        }
    }, [refresh])

    return (
        <>
            <Table
                rowKey={(record) => record.activity?.activity_id || record.id}
                scroll={{x: 400,}}
                dataSource={state?.listing}
                onChange={(pagination, filters, sorter) => {
                    // if(sorter){
                    //     const { field, order, } = sorter;
                    //     const sequel_order = order === 'ascend' ? 'ASC' : 'DESC';
                    //     // setSorter(sorter => ({...sorter, key : field, order : sequel_order,}));
                    // }
                }}
                pagination={{
                    size: state?.display_size,
                    current: (state?.count > state?.display_size) ? state?.page : 1,
                    total: state?.count,
                    showSizeChanger: false,
                    onChange: (page) => paginateChange('page', page)
                }}
                className='hub-table bordered'
                columns={[
                    {
                        title: 'Transaction No.',
                        dataIndex: ['activity', 'transaction_no'],
                        key: 'transaction_no',
                    },
                    {
                        title: "Status",
                        dataIndex: ["activity", "activity_status", "name"],
                        key: "activity_status_name",
                        render: (v, o) => {
                            const statusColorMap = {
                                SUCCESS: 'green',
                                PENDING: 'orange',
                                FAILED: 'red',
                                REFUNDED: 'volcano',
                            };

                            const color = statusColorMap[v?.toUpperCase()] || 'default';
                            return <Tag color={color}>{v}</Tag>;
                        }
                    }, {
                        title: 'Date',
                        dataIndex: 'created_at',
                        key: 'created_at',
                        render: (created_at, row, index) => {
                            return (
                                <>
                                    <span>{moment(created_at)?.format("YYYY-MM-DD hh:mm:ssa")}</span>
                                </>
                            )
                        }
                    }, {
                        title: 'Amount',
                        dataIndex: ['activity', 'melon_amount'],
                        key: 'amount',
                        render: (amount, row, index) => {
                            return (
                                <span>{numberHelper?.commaNumber(parseFloat(amount), 2)}</span>
                            )
                        }
                    },
                    {
                        title: 'Payment Amount',
                        dataIndex: 'payment_amount',
                        key: 'payment_amount',
                        render: (amount, row) =>
                            amount
                                ? `${row?.currency?.code}${numberHelper?.commaNumber(parseFloat(amount), 2)}`
                                : '-',
                    }
                ]}
            />
        </>
    );
}

export default MerchantSettlementList;